<script setup lang="ts">
import { OverviewTemplate } from '@/components/templates'
</script>

<template>
  <OverviewTemplate :getItemsFromRouter="true" />
</template>
